import { t } from "i18next";
import {
  type ApprovalCardItem,
  type ApprovalRawRecord,
  type ApprovalRawResponse,
  type ApprovalTabConfig,
  type ApprovalTabId,
} from "../types/approval";

const formatRequestedDate = (isoDate: string): string => {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const mapApprovalRecordToCardItem = (
  record: ApprovalRawRecord,
  sourceTab?: ApprovalTabId,
): ApprovalCardItem => ({
  id: record.transId,
  transId: record.transId,
  // tabId: record.category as Exclude<ApprovalTabId, "all">,
  tabId: sourceTab ?? record.category, // preserve "all" if passed
  debitBankName: record.debitBank,
  beneNickname: record.beneNickname,
  requestedDate: formatRequestedDate(record.crtdDt),
  referenceNumber: record.gxChnNo,
  amount: record.debitAmount,
  currencySymbol: record.currencySymbol ?? "--",
  numberOfApproved: record.numberOfApproved,
  numberOfLevels: record.numberOfLevels,
  paymentStatusCode: record.paymentStatusCode,
  raw: record.original ?? record,
  accountName: record.accountName,
  bankName: record.bankName,
  beneBankName: record.beneBankName,
  beneAccountHolderName: record.beneAccountHolderName,
  beneAccountName: record.beneAccountName,
});

export const mapApprovalResponseToCardItems = (
  response: ApprovalRawResponse,
): ApprovalCardItem[] => 
  // response.records.map(mapApprovalRecordToCardItem);
  response.records.map((record) => mapApprovalRecordToCardItem(record));

export const buildApprovalTabs = (
  counts: Record<ApprovalTabId, number>,
): ApprovalTabConfig[] => [
  { id: "all", labelKey: t("all"), count: counts.all },
  { id: "bulk", labelKey: t("bulk"), count: counts.bulk },
  { id: "bene", labelKey: t("bene"), count: counts.bene },
  { id: "payrolls", labelKey: t("payrolls"), count: counts.payrolls },
  { id: "txn", labelKey: t("txn_uppercase"), count: counts.txn },
];
